import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { TrackingTimeService } from '@/services/tracking-time/tracking-time-service';
import { TrackingTimeServiceImpl } from '@/services/tracking-time/impls/tracking-time-service-impl';

/** 页面参与度统计服务模块。 */
export const trackingTimeModule = new ContainerModule((bind) => {
    bind<TrackingTimeService>(TrackingTimeService).to(TrackingTimeServiceImpl);
});
